import { useEffect } from "react";
import Modal from "./Modal";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import { updateAdminComment } from "../../api/qrcode";

const schema = yup
  .object({
    adminComment: yup.string(),
  });

const AdminCommentModal = ({ setShowModal, refreshData, barCode }) => {
    console.log("barCode", barCode);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      adminComment: barCode?.adminComment,
    },
    mode: "onChange",
  });

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = methods;
  useEffect(() => {
    if (barCode?.adminComment) {
      setValue("adminComment", barCode?.adminComment);
      }
  }, [barCode, setValue]);

  const onSubmit = async (data) => {
    let obj = {
      adminComment: data?.adminComment,
    };
    try {
      await updateAdminComment(barCode?._id, obj);
      toast.success("Comment added successfully");
    } catch (error) {
      console.log("Error while updating qr code ", error);
      toast.error(
        error?.response?.data?.message || "Error while updating qr code"
      );
    } finally {
      refreshData();
      setShowModal(false);
    }
  };

  return (
    <>
      <Modal
        handleClick={() => setShowModal(false)}
        closeName="Cancel"
        submitName="Save"
        removeButtons
        title="Admin Comment"
      >
        <div className="flex flex-col px-[20px]">
          <div className="max-w-[800px] w-full mx-auto bg-white mt-4 sm:mt-6 rounded pt-3 pb-6 sm-pb-8">
            <div className="tab-content p-4 rounded-md max-w-[450px] w-full mx-auto">
              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className={`tab-pane`}>
                    <div className="flex flex-col mb-4 sm:mb-6">
                      <div className="relative">
                        <textarea
                          {...register("adminComment")}
                          rows={4}
                          placeholder="Put your comment here"
                            className={`w-full text-sm sm:text-base placeholder-gray-500 px-4 rounded-lg border ${
                              errors?.adminComment ? "border-red-500" : "border-gray-400"
                            } w-full py-3 focus:outline-none focus:border-blue-400`}
                          />
                        </div>
                        {errors?.adminComment && (
                          <span className="text-red-500 text-xs mt-1">
                            {errors.adminComment.message}
                          </span>
                        )}
                      </div>
                    </div>
                  <div className="flex justify-around gap-3 px-11">
                    <div className="w-full">
                      <button
                        type="submit"
                        className="justify-center w-full bg-[#0082B2] hover:bg-[#006d95] mb-2 text-white px-3 py-1 mr-4 rounded border border-borderMuted flex focus:outline-none transition-all duration-500"
                      >
                        <span>Save</span>
                      </button>
                    </div>
                    <div className="w-full">
                      <button
                        onClick={() => {
                          setShowModal(false);
                        }}
                        type="button"
                        className="justify-center w-full bg-red-500 hover:bg-red-600 mb-2 text-white px-3 py-1 mr-4 rounded border border-borderMuted flex focus:outline-none transition-all duration-500"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AdminCommentModal;
